import { InjectionToken } from '@angular/core';
import { ClientType } from '../models';

export const CLIENT_TYPE_TOKEN = new InjectionToken<ClientType>('CLIENT_TYPE_TOKEN');
